



































































import { ISite } from '@/entities/sites/site.interface';
import sitesApi from '@/api/sites.api';
import {
    SiteStatus,
    translateSiteStatus
} from '@/entities/sites/site-status.enum';
import store from '@/store/store';
import * as types from '@/store/types';

import { IConfirm } from '@/entities/confirm.interface';
import { ISort } from '@/entities/sort.interface';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';

import Component from 'vue-class-component';
import {mapGetters} from 'vuex';

@Component({
       computed: mapGetters({
            superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
        })
})
export default class SitesMasterPage extends MasterPageCriteria {
    public defaultSort: ISort = {
        field: 'sitename',
        asc: true
    };

    public items: ISite[] = [];

    public created() {
        this.search();
    }

    public activate(site: ISite) {
        this._updateStatus([site.id], SiteStatus.Activated, 'Are you sure? Flag\n \'Use CardApprove, Sale\' will be set too');
    }

    public suspend(site: ISite) {
        this._updateStatus([site.id], SiteStatus.Suspended, 'Are you sure? Flag\n \'Use CardApprove, Sale\' will be unset too');
    }

    public list(body: ISearchBody): Promise<IPaging<ISite>> {
        return sitesApi.search(body);
    }

    private _updateStatus(
        ids: number[],
        status: SiteStatus,
        heading: string = 'Are you sure?'
    ) {
        let afterFn = (closeFn: () => void) => {
            sitesApi
                .updateStatusBatch(ids, { status })
                .then(() => {
                    this.selected = [];
                    this._updateSitesStatus(ids, status);
                    closeFn();
                })
                .catch(() => closeFn());
        };
        let payload: IConfirm = {
            heading,
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    private _updateSitesStatus(ids: number[], status: SiteStatus) {
        this.items = this.items.map((item) => {
            if (ids.indexOf(item.id) === -1) {
                return item;
            } else {
                return { ...item, status };
            }
        });
    }
}
